import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import FadeLoader from "react-spinners/FadeLoader";
import AUEnergyPackageModal from "components/Modals/AUEnergyPackages";
import Table from "components/Table";
import Columns from "./Columns";
import {
  deleteEnergyPackage,
  getEnergyPackagesList,
} from "store/energyPackages/actions";
import { checkPermissions } from "helpers/common";

const List = () => {
  const dispatch = useDispatch();

  const { loading, energyPackageList, totalCount } = useSelector(
    ({ EnergyPackage }) => ({
      loading: EnergyPackage?.loading,
      energyPackageList: EnergyPackage?.energyPackageList,
      totalCount: EnergyPackage?.totalCount,
    }),
  );

  const [columns, setcolumns] = useState([{ dataField: "", text: "" }]);
  const [addEnergyPackage, setAddEnergyPackagePop] = useState(false);
  const [rowData, setRowData] = useState(null);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 20,
    order: -1,
    orderBy: "date_created_utc",
    search: "",
  });

  const { user } = useSelector((state) => state.Auth);
  const [permissions, setPermissions] = useState({
    add: false,
    edit: false,
    delete: false,
  });

  useEffect(() => {
    if (user?.permissions) {
      setPermissions({
        add: checkPermissions(["add_energy_package"], user?.permissions),
        edit: checkPermissions(["edit_energy_package"], user?.permissions),
        delete: checkPermissions(["delete_energy_package"], user?.permissions),
      });
    }
  }, [user]);

  useEffect(() => {
    getApiData(filter);
    setcolumns(
      Columns({ deleteHandler, handleEdit, permissions })?.filter((item) => {
        if (
          item?.text === "Action" &&
          !permissions.edit &&
          !permissions.delete
        ) {
          return false;
        }
        return true;
      }),
    );
  }, [filter, permissions]);

  async function getApiData() {
    try {
      dispatch(getEnergyPackagesList({ data: filter }));
    } catch (error) {}
  }

  const deleteHandler = (id) => {
    try {
      const userConfirmed = window.confirm(
        "Are you sure, you want to delete this energy package?",
      );
      if (userConfirmed) {
        const callback = (err, res) => {
          if (err) {
          } else {
            getApiData(filter);
          }
        };

        dispatch(
          deleteEnergyPackage({
            data: { _id: id },
            callback,
          }),
        );
      }
    } catch (error) {
      console.error(error, "<===err");
    }
  };

  const handleEdit = (info) => {
    setRowData(info);
    setAddEnergyPackagePop(true);
  };

  return (
    <>
      {addEnergyPackage && (
        <AUEnergyPackageModal
          rowData={rowData}
          show={addEnergyPackage}
          loading={loading}
          handleClose={() => {
            setRowData(null);
            setAddEnergyPackagePop(false);
          }}
        />
      )}
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      <Helmet title={"Energy Packages"} />

      <section className="section">
        <div className="section-header">
          <h1>{"Energy Packages"}</h1>

          {/* <div className="section-header-breadcrumb">
            <div className="breadcrumb-item active">
              <Link to={"/admin/" + Path.dashboard}>Dashboard</Link>
            </div>
            <div className="breadcrumb-item">{"Energy Packages"} </div>
          </div> */}
        </div>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-6">
                <div className="card-header">
                  <h2 className="section-title">{"Energy Packages"}</h2>
                </div>
              </div>
              {permissions.add ? (
                <div className="col-6">
                  <div className="card-header d-flex justify-content-end align-items-center">
                    <button
                      className="btn btn-primary"
                      onClick={() => setAddEnergyPackagePop(true)}
                    >
                      Add Energy Package
                    </button>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
          {!loading && energyPackageList?.length > 0 && (
            <Table
              data={energyPackageList}
              columns={columns}
              // setFilter={setFilter}
              total={totalCount}
              // filter={filter}
              toggleConfirmModal={deleteHandler}
            />
          )}
          {!loading && energyPackageList?.length === 0 && (
            <p style={{ textAlign: "center" }}>No Energy Package Found</p>
          )}
        </div>
      </section>
    </>
  );
};

export default List;
